<template>
  <b-modal v-model="show" title="ПАРАМЕТЕР" size="lg" :no-close-on-esc="true" :no-close-on-backdrop="true">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("fitment.fitmentType") }} <span class="red">*</span></label>

            <div class="list-group">
              <label
                  v-for="option in fitmentPropertyTypes"
                  :key="option.key"
                  class="list-group-item d-flex align-items-start"
              >
                <input
                    type="checkbox"
                    class="form-check-input me-2 mt-1"
                    :value="option.key"
                    v-model="dictionaryData.data.fitmentTypes"
                />
                <span>{{ option.name }}</span>
              </label>
            </div>
          </div>


          <!--          <div class="form-group">-->
          <!--            <label>{{ $t("fitment.fitmentType") }} <span class="red">*</span></label>-->
          <!--            <select class="form-control" v-model="dictionaryData.fitmentType">-->
          <!--              <option :value="option.key" v-for="option in fitmentTypes" :key="option.key">-->
          <!--                {{ option.name }}-->
          <!--              </option>-->
          <!--            </select>-->
          <!--          </div>-->
          <div class="form-group">
            <label>Сана <span class="red">*</span></label>
            <date-picker class="form-control" format="dd/MM/yyyy"
                         v-model="analysisDate"
                         :clear-button="true"
                         :class="{invalid : $v.analysisDate.$error}">
            </date-picker>
          </div>
          <div class="form-group">
            <label>Текст <span class="red">*</span></label>
            <textarea
                class="form-control"
                v-model="dictionaryData.data.description"
                :class="{invalid: $v.dictionaryData.data.description.$error}"
            ></textarea>
          </div>
          <div>
            <button v-b-toggle.html-view1 class="all-btn m-1">Html view</button>
            <b-collapse visible id="html-view1">
              <div class="card">
                <span class="ml-2" v-html="dictionaryData.data.description"></span>
              </div>
            </b-collapse>
          </div>
          <div class="mx-n3">
            <DropZone code="marketAnalysis"
                      folder="Settings"
                      subFolder="MarketAnalysis"
                      acceptedFiles="image/*"
                      label="Илова *"
                      view="BUILDING" :data="dictionaryData.applications"
                      @change="(photos) => {dictionaryData.applications = photos}"
            />
            <!--:has-error="$v.dictionaryData.applications.$error"-->
          </div>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
      <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_FITMENT_MARKET_ANALYSIS_ADD')"
              @click="save" :disabled="processing">
        Сақлаш
      </button>
      <button class="all-btn delete-btn float-right mr-2" @click="close">
        Бекор қилиш
      </button>
    </div>
  </b-modal>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import DropZone from '@/views/dropZone/DropZone'
import DatePicker from 'vuejs-datepicker';
import {formatDate, parseDate} from '@/shared/utils';
import {required, minLength} from 'vuelidate/lib/validators';
import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
import {VBToggle} from 'bootstrap-vue/es/directives/toggle/toggle'
import initFilterModel from '@/shared/filter';
import {FITMENT_PROPERTY_TYPES} from '@/shared/constants/fitment'

export default {
  name: "FitmentMarketAnalysisEditModal",
  components: {
    'b-modal': bModal,
    DropZone,
    'date-picker': DatePicker,
    BCollapse
  },
  directives: {
    'b-modal': bModalDirective,
    'b-toggle': VBToggle
  },
  data() {
    return {
      show: false,
      processing: false,
      filterProvince: initFilterModel(),
      dictionaryData: this.initData(),
      fitmentPropertyTypes: FITMENT_PROPERTY_TYPES,
      fitmentType: null,
      analysisDate: null
    }
  },
  validations() {
    return {
      dictionaryData: {
        data: {

          description: {
            required: required
          },
          fitmentTypes: {
            required,
            minLength: minLength(1)
          }
        }
        // fitmentType: {
        //   required: required
        // }
        // applications: {
        //     required: required,
        //     minLength: minLength(1)
        // }
      },
      analysisDate: {
        required: required
      }
    }
  },
  methods: {
    initData() {
      return {
        id: null,
        dictionaryType: 'FITMENT_MARKET_ANALYSIS',
        data: {
          fitmentTypes: [],
          description: ''
        },
        applications: []
      }
    },
    init() {
      const vm = this;
      vm.filterProvince.search = '';
      this.$http.post('/province/list', vm.filterProvince)
          .then(res => {
            this.getAsMaps(res.data);
          }, err => {
            console.log(err);
          });
    },
    getAsMaps(result) {
      if (result && result.data && result.data.length > 0) {
        return result.data.map(d => ({id: d.id, name: d.name}))
      }
      return [];
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      if (this.analysisDate) {
        this.dictionaryData.data.analysisDate = formatDate(this.analysisDate);
      }

      const vm = this;
      this.processing = true;
      this.$http.post('dictionary/save/fitment/market-analysis', this.dictionaryData)
          .then(res => {
            const response = res.data;
            if (response.status === 'SUCCESS') {
              vm.show = false;
              this.dictionaryData = this.initData()
              this.$emit('change')
            }
            vm.processing = false;
          }, err => {
            vm.processing = false;
            console.log(err);
          });
    },
    close() {
      this.show = false
    }
  },
  created() {
    this.filterProvince.page.size = 1000;
    this.init();
    this.$eventBus.$on('showFitmentMarketAnalysisEditModal', (data) => {
      console.log(data)
      if (data) {
        this.dictionaryData = data
        this.analysisDate = parseDate(this.dictionaryData.data.analysisDate)
      } else {
        this.dictionaryData = this.initData();
        this.analysisDate = null;
      }
      this.show = true;
    })
  }
}
</script>

<style scoped>

</style>